module.exports = __webpack_public_path__ + "img/Warberg-IC.2a804145.png";